import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export default function multiColumnAnimations(section) {
    const blocks = Array.from(section.querySelectorAll('.multi-column .col'))

    if(blocks.length > 0) {

        gsap.timeline({
            scrollTrigger: {
                trigger: blocks,
                start: 'top 80%'
            }
        }).to(blocks, {
            stagger: .2, opacity: 1, translateY: 0
        })
    }
}
